import { TFunction } from 'i18next';
import { setLocale } from 'yup';

export const setYupLocale = (t: TFunction) => {
    // Project-wide validation message defaults
    setLocale({
        mixed: {
            default: t('Validation.InvalidValue'),
            required: t('Validation.FieldRequired'),
        },
        string: {
            max: ({ max }) => t('Validation.MaxChars', { count: max }),
            min: ({ min }) => t('Validation.MinChars', { count: min }),
            email: () => t('Validation.InvalidValue'),
        },
        array: {
            max: () => t('Validation.MaxSelected'),
        },
    });
};
